import {
  AfterContentChecked,
  Component,
  ElementRef,
  Injector,
  OnInit,
  ViewChild
} from '@angular/core';
import { NavParams } from '@ionic/angular';
import * as firebase from 'firebase/app';
import 'firebase/app';
import { forkJoin } from 'rxjs/internal/observable/forkJoin';
import { Extender } from 'src/shared/helpers/extender';
import { Account, Conversation, Message } from 'src/shared/models';
import { ChatService } from '../../services/chat/chat.service';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss']
})
export class MessageComponent extends Extender
  implements OnInit, AfterContentChecked {
  /**
   * @property me
   * @type Account
   */
  public me: Account;

  /**
   * @property conversation
   * @type Conversation
   */
  public conversation: Conversation;

  /**
   * @property messages
   * @type Message[]
   */
  public messages: Message[] | any;

  /**
   * @property messagesBackUp
   * @type Message[]
   */
  public messagesBackUp: Message[];

  /**
   * @property message
   * @type FormControl
   * @default new FormControl()
   */
  public message: string = '';

  /**
   * references content area of content page
   * @property content
   * @type Content
   */
  @ViewChild('content', null) public content: ElementRef;

  /**
   * @constructor
   * @param injector {Injector}
   * @param rt {RealTime}
   */
  constructor(
    protected injector: Injector,
    private navParams: NavParams,
    private chatService: ChatService
  ) {
    super(injector);
  }

  /**
   * get current user's contact
   * get conversation from nav params
   * get real time reference to Conversation and reference
   * to Message model as child of conversation
   * listen to change event of Messages model and update is_read toidentify that the message is read
   * @method ngOnInit
   * @return void
   */
  public ngOnInit(): void {
    this.auth$.user$.subscribe((user) => {
      if (user) {
        this.me = user;
        this.chatService
          .getConversation(this.navParams.get('data'))
          .subscribe((doc: Conversation) => (this.conversation = doc));
      }
    });
  }

  public ngAfterContentChecked(): void {
    this.scrollToBottom();
  }

  /**
   * search messages
   * @method onSearch
   * @param ev
   */
  public onSearch(ev: any): void {
    const val = ev.target.value;
    this.messages = [...this.messagesBackUp];
    if (val && val.trim() !== '') {
      this.messages = this.messages.filter((item) => {
        return item.text.toLowerCase().indexOf(val.toLowerCase()) > -1;
      });
    }
  }

  /**
   * send message,build a message object with data
   * from conversation and from the text to be sent
   * create message entry then reset message input field
   * @method send
   * @param {string} message
   */
  public async send(content) {
    const { uid } = await this.auth$.getUser();

    const data = {
      uid,
      content,
      createdAt: Date.now()
    };

    if (uid) {
      const ref = this.afStore$
        .collection('conversations')
        .doc(this.conversation.id);
      return ref
        .update({
          messages: firebase.firestore.FieldValue.arrayUnion(data)
        })
        .then(() => this.autoReply());
    }
  }

  /**
   * on message hold open action sheet
   * options in action sheet to delete message
   * @method onMessageHold
   * @param e
   * @param itemIndex
   * @param message
   */
  public async onMessageHold(message: Message): Promise<any> {
    if (message.uid === this.me.uid) {
      const actionSheet = await this.actionSheetCtrl.create({
        header: this.translate.instant('ChatModule.options'),
        buttons: [
          {
            text: this.translate.instant('Other.delete-label'),
            role: 'Destructive',
            handler: () => {
              const ref = this.afStore$
                .collection('conversations')
                .doc(this.conversation.id);
              return ref
                .update({
                  messages: firebase.firestore.FieldValue.arrayRemove(message)
                })
                .then(() => this.scrollToBottom());
            }
          },
          {
            text: this.translate.instant('Other.cancel'),
            role: 'cancel',
            handler: () => {}
          }
        ]
      });
      await actionSheet.present();
    }
  }

  /**
   * send photo either from camera or photo library
   * @method sendPhoto
   * @return {void}
   */
  public async sendPhoto(): Promise<any> {
    // const actionSheet = await this.actionSheetCtrl.create({
    //   header: this.translate.instant('ChatModule.send-image'),
    //   buttons: [
    //     {
    //       text: this.translate.instant('Other.camera'),
    //       handler: () => {
    //         this.imageUpload(1)
    //           .then((result) => {
    //             this.send(result, true);
    //           });
    //       }
    //     },
    //     {
    //       text: this.translate.instant('Other.photo-library'),
    //       handler: () => {
    //         this.imageUpload(0)
    //           .then((result) => {
    //             this.send(result, true);
    //           });
    //       }
    //     },
    //     {
    //       text: this.translate.instant('Other.cancel'),
    //       role: 'cancel',
    //       handler: () => {
    //       }
    //     }
    //   ]
    // });
    // await actionSheet.present();
  }

  public scrollToBottom(): void {
    const element = document.getElementById('last-item');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'end',
        inline: 'nearest'
      });
    }
  }

  public trackByCreated(i, msg) {
    return msg.createdAt;
  }

  private autoReply() {
    setTimeout(() => {
      const ref = this.afStore$
        .collection('conversations')
        .doc(this.conversation.id);
      return ref.update({
        messages: firebase.firestore.FieldValue.arrayUnion({
          uid: this.conversation.rid,
          content: msgs[Math.floor(Math.random() * msgs.length)].message,
          createdAt: Date.now()
        })
      });
    }, Math.floor(Math.random() * 6000) + 1000);
  }
}

const msgs = [
  {
    message: 'Integer ac leo.'
  },
  {
    message: 'In eleifend quam a odio.'
  },
  {
    message: 'Donec ut mauris eget massa tempor convallis.'
  },
  {
    message: 'Maecenas tincidunt lacus at velit.'
  },
  {
    message: 'Phasellus in felis.'
  },
  {
    message: 'Donec odio justo, sollicitudin ut, suscipit a, feugiat et, eros.'
  },
  {
    message: 'Nulla tellus.'
  },
  {
    message: 'In eleifend quam a odio.'
  },
  {
    message: 'Nulla justo.'
  },
  {
    message: 'Pellentesque at nulla.'
  },
  {
    message: 'Nam tristique tortor eu pede.'
  },
  {
    message: 'Donec dapibus.'
  },
  {
    message: 'Donec ut mauris eget massa tempor convallis.'
  },
  {
    message: 'Fusce posuere felis sed lacus.'
  },
  {
    message: 'In blandit ultrices enim.'
  },
  {
    message: 'Morbi porttitor lorem id ligula.'
  },
  {
    message: 'Mauris sit amet eros.'
  },
  {
    message: 'Nullam porttitor lacus at turpis.'
  },
  {
    message: 'Nunc nisl.'
  },
  {
    message: 'Nulla ac enim.'
  },
  {
    message: 'Cras non velit nec nisi vulputate nonummy.'
  },
  {
    message: 'Curabitur at ipsum ac tellus semper interdum.'
  },
  {
    message: 'Nunc purus.'
  },
  {
    message: 'In hac habitasse platea dictumst.'
  },
  {
    message: 'Curabitur at ipsum ac tellus semper interdum.'
  },
  {
    message: 'Duis ac nibh.'
  },
  {
    message: 'Duis at velit eu est congue elementum.'
  },
  {
    message: 'Pellentesque at nulla.'
  },
  {
    message: 'Praesent blandit.'
  },
  {
    message: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit.'
  },
  {
    message: 'Quisque porta volutpat erat.'
  },
  {
    message: 'Pellentesque viverra pede ac diam.'
  },
  {
    message: 'Etiam vel augue.'
  },
  {
    message: 'Etiam pretium iaculis justo.'
  },
  {
    message: 'Nullam varius.'
  },
  {
    message: 'Morbi porttitor lorem id ligula.'
  },
  {
    message: 'Suspendisse accumsan tortor quis turpis.'
  },
  {
    message: 'Mauris sit amet eros.'
  },
  {
    message: 'Vivamus in felis eu sapien cursus vestibulum.'
  },
  {
    message: 'Integer non velit.'
  },
  {
    message: 'Maecenas tincidunt lacus at velit.'
  },
  {
    message:
      'Vestibulum quam sapien, varius ut, blandit non, interdum in, ante.'
  },
  {
    message: 'Morbi odio odio, elementum eu, interdum eu, tincidunt in, leo.'
  },
  {
    message:
      'Vivamus metus arcu, adipiscing molestie, hendrerit at, vulputate vitae, nisl.'
  },
  {
    message: 'Quisque id justo sit amet sapien dignissim vestibulum.'
  },
  {
    message: 'Mauris lacinia sapien quis libero.'
  },
  {
    message: 'Vivamus vel nulla eget eros elementum pellentesque.'
  },
  {
    message: 'Phasellus in felis.'
  },
  {
    message:
      'Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.'
  },
  {
    message: 'Integer ac neque.'
  },
  {
    message: 'Integer a nibh.'
  },
  {
    message: 'Aliquam non mauris.'
  },
  {
    message: 'Vivamus vestibulum sagittis sapien.'
  },
  {
    message: 'Morbi vel lectus in quam fringilla rhoncus.'
  },
  {
    message: 'Integer ac neque.'
  },
  {
    message: 'Morbi non quam nec dui luctus rutrum.'
  },
  {
    message: 'Sed accumsan felis.'
  },
  {
    message: 'Vestibulum sed magna at nunc commodo placerat.'
  },
  {
    message:
      'Maecenas leo odio, condimentum id, luctus nec, molestie sed, justo.'
  },
  {
    message: 'Donec ut dolor.'
  },
  {
    message:
      'Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.'
  },
  {
    message: 'In blandit ultrices enim.'
  },
  {
    message: 'Donec semper sapien a libero.'
  },
  {
    message: 'Nam dui.'
  },
  {
    message: 'In sagittis dui vel nisl.'
  },
  {
    message: 'Nam tristique tortor eu pede.'
  },
  {
    message: 'Nulla ut erat id mauris vulputate elementum.'
  },
  {
    message: 'Proin risus.'
  },
  {
    message: 'Proin eu mi.'
  },
  {
    message:
      'Quisque erat eros, viverra eget, congue eget, semper rutrum, nulla.'
  },
  {
    message:
      'Morbi vestibulum, velit id pretium iaculis, diam erat fermentum justo, nec condimentum neque sapien placerat ante.'
  },
  {
    message: 'Vivamus in felis eu sapien cursus vestibulum.'
  },
  {
    message: 'Nulla justo.'
  },
  {
    message: 'Aenean auctor gravida sem.'
  },
  {
    message: 'Nunc nisl.'
  },
  {
    message: 'Sed accumsan felis.'
  },
  {
    message: 'Quisque ut erat.'
  },
  {
    message: 'Morbi vel lectus in quam fringilla rhoncus.'
  },
  {
    message: 'In est risus, auctor sed, tristique in, tempus sit amet, sem.'
  },
  {
    message: 'Nulla mollis molestie lorem.'
  },
  {
    message: 'In hac habitasse platea dictumst.'
  },
  {
    message: 'Quisque porta volutpat erat.'
  },
  {
    message: 'Cras pellentesque volutpat dui.'
  },
  {
    message: 'Aenean fermentum.'
  },
  {
    message: 'Sed sagittis.'
  },
  {
    message: 'Ut at dolor quis odio consequat varius.'
  },
  {
    message: 'Nullam varius.'
  },
  {
    message: 'Nullam molestie nibh in lectus.'
  },
  {
    message: 'In congue.'
  },
  {
    message: 'Nunc purus.'
  },
  {
    message: 'Integer ac neque.'
  },
  {
    message: 'Fusce lacus purus, aliquet at, feugiat non, pretium quis, lectus.'
  },
  {
    message:
      'Vivamus metus arcu, adipiscing molestie, hendrerit at, vulputate vitae, nisl.'
  },
  {
    message: 'Duis bibendum.'
  },
  {
    message: 'Quisque porta volutpat erat.'
  },
  {
    message: 'Maecenas rhoncus aliquam lacus.'
  },
  {
    message:
      'Nam ultrices, libero non mattis pulvinar, nulla pede ullamcorper augue, a suscipit nulla elit ac nulla.'
  },
  {
    message: 'Maecenas ut massa quis augue luctus tincidunt.'
  },
  {
    message:
      'Vestibulum quam sapien, varius ut, blandit non, interdum in, ante.'
  },
  {
    message: 'Quisque arcu libero, rutrum ac, lobortis vel, dapibus at, diam.'
  }
];
